<div class="dialog-container" style="padding: 16px; min-width: 380px;">
    <h2 mat-dialog-title style="margin-top: 0; font-size: 18px; font-weight: 500;">Import Bulk Updates</h2>
    <div mat-dialog-content style="padding: 12px 0 16px 0; display: flex; flex-direction: column; gap: 12px;">

        <!-- File Picker -->
        <div>
            <label style="display: block; font-weight: 500; margin-bottom: 6px; font-size: 13px;">Excel File:</label>
            <div class="drag-drop-zone" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="fileInput.click()"
                style="border: 2px dashed #ccc; border-radius: 6px; padding: 24px 16px; text-align: center; background-color: #fafafa; cursor: pointer; transition: all 0.2s ease-in-out; display: flex; flex-direction: column; align-items: center; gap: 8px;">

                <input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx, .xls"
                    style="display: none;">

                <mat-icon
                    style="font-size: 32px; width: 32px; height: 32px; color: #1976d2; line-height: 32px;">cloud_upload</mat-icon>

                <div *ngIf="!importFile" style="font-size: 13px; color: #555;">
                    Drag & Drop your Excel file here or <span
                        style="color: #1976d2; font-weight: 500; text-decoration: underline;">Browse</span>
                </div>

                <div *ngIf="importFile"
                    style="display: flex; align-items: center; gap: 6px; background-color: #e3f2fd; border-radius: 4px; padding: 4px 8px; max-width: 100%;">
                    <mat-icon
                        style="font-size: 16px; width: 16px; height: 16px; line-height: 16px; color: #1565c0;">description</mat-icon>
                    <span
                        style="font-size: 12px; font-weight: 500; color: #1565c0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 200px;">
                        {{ importFile.name }}
                    </span>
                    <button mat-icon-button (click)="removeFile($event)"
                        style="width: 20px; height: 20px; line-height: 20px; min-width: unset; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                        title="Remove File">
                        <mat-icon
                            style="font-size: 14px; width: 14px; height: 14px; line-height: 14px; color: #555;">close</mat-icon>
                    </button>
                </div>
            </div>
            <div style="color: #e53935; font-size: 12px; margin-top: 4px;" *ngIf="importFileError">
                {{ importFileError }}
            </div>
        </div>

        <!-- Date Picker -->
        <div>
            <label style="display: block; font-weight: 500; margin-bottom: 6px; font-size: 13px;">Publish Date:</label>
            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Select Date</mat-label>
                <input matInput [matDatepicker]="importDatePicker" [min]="minDate" [(ngModel)]="importDateVal" readonly>
                <mat-datepicker-toggle matIconSuffix [for]="importDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #importDatePicker></mat-datepicker>
            </mat-form-field>
            <div style="color: #e53935; font-size: 12px; margin-top: -8px;" *ngIf="importDateError">
                {{ importDateError }}
            </div>
        </div>

        <div *ngIf="update_schedule_at"
            style="color: #ff9800; font-size: 12px; border-left: 3px solid #ff9800; padding-left: 8px; margin-top: 8px; background-color: #fff8e1; padding: 6px 10px; border-radius: 2px;">
            Warning: Importing a new spreadsheet will overwrite all currently staged revisions.
        </div>
    </div>
    <div mat-dialog-actions
        style="display: flex; justify-content: flex-end; gap: 8px; padding-top: 8px; border-top: 1px solid #eee;">
        <button mat-button (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="isUploading" (click)="confirmImport()">
            <span *ngIf="!isUploading">Import</span>
            <span *ngIf="isUploading">Uploading...</span>
        </button>
    </div>
</div>